import { Navigate, useLocation } from "react-router-dom";
import {
  DEFAULT_LOCALE,
  getLocaleFromPath,
  withLocale,
} from "../../config/locales";

const LanguageRedirect = () => {
  const { pathname } = useLocation();
  const currentLocale = getLocaleFromPath(pathname) ?? DEFAULT_LOCALE;
  return <Navigate to={withLocale(currentLocale, "/home")} replace />;
};

export default LanguageRedirect;
